// extracted by extract-css-chunks-webpack-plugin
module.exports = {"panel":"styles__panel___2n0uR","panel-header":"styles__panel-header___3htfA","panelHeader":"styles__panel-header___3htfA","panel-highlight":"styles__panel-highlight___3ZXs0","panelHighlight":"styles__panel-highlight___3ZXs0","panel-body":"styles__panel-body___1HL-v","panelBody":"styles__panel-body___1HL-v"};
    if(module.hot) {
      // 1776124301854
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  